export const actions = [
	"auctionData/addLot",
	"auctionData/addLots",
	"auctionData/updateLot",
	"auctionData/deleteLot",
	"auctionData/resetLotCosts",
	"auctionData/updateLotCostByIndex",
];
